/** Standard page-size options used across all data grids and tables. */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
